import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Widget/Widget.js";
import "HSNDIR/Widget/Tabs.js";
import Events from "HSNDIR/Events.js";


/**
    * class HSN.Template.Bag
    *
    * Encapsulates the functionality the Communication Brands page.
    **/
var brandSelections = [];
var emailPrefSelections = [];
var mobilePrefSelections = [];
var currentCategorySelected = '';
var currentBrandNameSelected = '';
var currentBrandModalPage = 1;
    
HSN.Template.CommPrefBrands = function (config) {
    /**
        * new HSN.Template.Bag(config)
        * - config (Object): A configuration object for the [[HSN.Template.OrderHistory]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the template should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the template.
        **/

    var __scope = this;

    this._application = config.application;
    this._container = $(config.container);
    this.eventCoordinator = this._application.Events;
   

    this._application.Events.On(HSN.Modal.EVENT.MODAL_CLOSE, function () {
        brandSelections = [];
        HSN.Instance().GetBrandsEditModal().Hide();
        return;
    });

    this._application.Events.On(HSN.Modal.EVENT.MODAL_CLOSE, function () {
        brandSelections = [];
        HSN.Instance().GetBrandsEditModal().Hide();
        return;
    });

    this.eventCoordinator.On(Events.Widget.Tabs.SHOW, (element) => {
        __scope.PopulateBrands(element.data('catid'), element.data('catname'));
    }, 'Tabs');


    $('#template-brands-all-tab').on('click', function (e) {
        $("#template-brands-all").addClass("active");
        $('#template-brands-selected-container').parent().removeClass("active");
        return false;
    });

    $('#all-brands-form :input:not(#select_all)').on('change', function (e) {
        if ($(this).is(':checked')) {
                        
            if ($(this).attr('originalvalue') == "True") {
                var value = $(this).val();
                for(var currentObj = 0; currentObj < brandSelections.length; currentObj++) {
                    if(brandSelections[currentObj].value === value) {
                        brandSelections.splice(currentObj, 1);
                    }
                }
            }
            else {
                brandSelections.push({ 'name' : 'SelectedBrands', 'value' : $(this).val() });
                            
            }
        } 
        else {
            if($(this).attr('originalvalue') == "True") {
                brandSelections.push({ 'name' : 'UnselectedBrands', 'value' : $(this).val() });
            }
            else {
                var value = $(this).val();
                            
                for(var currentObj = 0; currentObj < brandSelections.length; currentObj++) {
                    if(brandSelections[currentObj].value === value) {
                        brandSelections.splice(currentObj, 1);
                    }
                }
            }
        }
    });

    $('#select_all').on('change', function () {
        $('#preferences-brands-save-button').removeClass('animated-save-btn');
        $('#preferences-brands-save-button').css('display', 'inline-block');
        if(this.checked) {
            $('.brand-item').each(function() {
                    this.checked = true;
                    $(this).trigger('change');
                });
        }
        else {
            $('.brand-item').each(function() {
                this.checked = false;
                $(this).trigger('change');
            });
        }
    });

    $('.brand-item').on('click', function () {
        $('#preferences-brands-save-button').css('display', 'inline-block');
        $('#preferences-brands-save-button').removeClass('animated-save-btn');
        if ($('.brand-item:checked').length === $('.brand-item').length) {
            $('#select_all').prop('checked', true);
        } else {
            $('#select_all').prop('checked', false);
        }
    });
        
    $('.category-list').on('click', function (e) {
        $(".category-list").removeClass("category-list-active");
        $(this).addClass("category-list-active");            
    });        
};
HSN.Template.CommPrefBrands.prototype =
{
    BrandPagePrevious : function() {

        var container = $("#all-brands-container");

        var currentPage = container.data("currentpage");
        if(currentPage > 1) {
            var nextPage = currentPage - 1;
            container.data("currentpage", nextPage);
            $("#all-brands-currentpage").val(nextPage);

            var pageSize = container.data("pagesize");
            var totalItems = container.data("totalitems");

            var showStartIndex = (nextPage - 1) * pageSize;
            var showEndIndex = showStartIndex + pageSize - 1;
            if(showEndIndex > (totalItems - 1))
                showEndIndex = totalItems - 1;

            container.find("ul").hide();
            if(showEndIndex == showStartIndex)
                container.find("ul").slice(showStartIndex).show("fast");
            else
                container.find("ul").slice(showStartIndex, showEndIndex + 1).show("fast");
        }
    },

    BrandPageNext : function() {
        var container = $("#all-brands-container");

        var currentPage = container.data("currentpage");
        var totalPages = container.data("totalpages");
        if(currentPage < totalPages) {
            var nextPage = currentPage + 1;
            container.data("currentpage", nextPage);
            $("#all-brands-currentpage").val(nextPage);

            var pageSize = container.data("pagesize");
            var totalItems = container.data("totalitems");

            var showStartIndex = currentPage * pageSize;
            var showEndIndex = showStartIndex + pageSize - 1;
            if(showEndIndex > (totalItems - 1))
                showEndIndex = totalItems - 1;

            container.find("ul").hide();
            if(showEndIndex == showStartIndex)
                container.find("ul").slice(showStartIndex).show("fast");
            else
                container.find("ul").slice(showStartIndex, showEndIndex + 1).show("fast");
        }
    },

    BrandPageSelect: function (page) {

            var container = $("#all-brands-container");
            var currentPage = container.data("currentpage");

            if (page != currentPage) {

                var selectedPage = Number(page);  

                container.data("currentpage", selectedPage);
                $("#all-brands-currentpage").val(selectedPage);

                var pageSize = container.data("pagesize");
                var totalItems = container.data("totalitems");

                var showStartIndex = (selectedPage - 1) * pageSize;  
                var showEndIndex = showStartIndex + pageSize - 1; 
                if (showEndIndex > (totalItems - 1))  
                    showEndIndex = totalItems - 1;  

                container.find("ul").hide();
                if (showEndIndex == showStartIndex)
                    container.find("ul").slice(showStartIndex).show("fast");
                else
                    container.find("ul").slice(showStartIndex, showEndIndex + 1).show("fast");
            }
        },

    BindEmailPreferences: function () {
        $('.email-pref-item').on('change', function (e) {
                if ($(this).is(':checked')) {

                    if ($(this).attr('originalvalue') == "selected") {
                        var value = $(this).val();

                        $.each(emailPrefSelections, function (i) {
                            if (this.value === value) emailPrefSelections.splice(i, 1);
                        });
                    }

                    else {
                        emailPrefSelections.push({ 'name': 'SelectedEmailPref', 'value': $(this).val() });
                    }
                } 
                    
                else {
                    if ($(this).attr('originalvalue') == "selected") {
                        emailPrefSelections.push({ 'name': 'UnselectedEmailPref', 'value': $(this).val() });
                    } 
                    else {
                            
                        var value = $(this).val();
                        $.each(emailPrefSelections, function (i) {
                            if (this.value == value) emailPrefSelections.splice(i, 1);
                        });
                    }
                }
            });       
    },
        BindMobilePreferences: function () {
            $('.text-pref-item').on('change', function (e) {
                if ($(this).is(':checked')) {

                    if ($(this).attr('originalvalue') == "selected") {
                        var value = $(this).val();

                        $.each(mobilePrefSelections, function (i) {
                            if (this.value === value) mobilePrefSelections.splice(i, 1);
                        });
                    }
                    else {
                        mobilePrefSelections.push({ 'name': 'SelectedMobilePref', 'value': $(this).val() });
                    }
                } 
                    
                else {
                    if ($(this).attr('originalvalue') == "selected") {
                        mobilePrefSelections.push({ 'name': 'UnselectedMobilePref', 'value': $(this).val() });
                    } else {

                        var value = $(this).val();

                        $.each(mobilePrefSelections, function (i) {
                            if (this.value == value) mobilePrefSelections.splice(i, 1);
                        });
                    }
                }
            });
        },

        PopulateBrands: function (categoryId, categoryName, isReload) {
            var scope = this;
            currentCategorySelected = categoryId;
            currentBrandNameSelected = categoryName;
            currentBrandModalPage = $('#all-brands-currentpage').val();
               
            $.ajax(
                "/myaccount/compref/brands/get-by-category?catid=" + categoryId + "&catname=" + encodeURIComponent(categoryName),
                {
                    context: this,
                    dataType: 'html',
                    success: function (data, status, xhr) {
                        $('#brand-list').html(data);
                        if(isReload && currentBrandModalPage) {
                            scope.BrandPageSelect(currentBrandModalPage);
                        } 
                    }
                }
            );
        },

        CancelBrands: function () {

            var sAllBrandsTab = $("#template-brands-all").hasClass("active");

            if (sAllBrandsTab) {

                var selectedCat = $('#template-brands-all .category-list-active').data('catid');

                if(selectedCat != null) {

                    $.ajax(
                        "/myaccount/compref/brands/get-by-category?catid=" + selectedCat,
                        {
                            context: this,
                            dataType: 'html',
                            success: function (data, status, xhr) {
                                $('#brand-list').html(data);
                            }
                        }
                    );
                }
            }
            else {

                $.ajax(
                    "/myaccount/compref/brands/get-selected?_ts" + new Date().getTime(),
                    {
                        context: this,
                        dataType: 'html',
                        success: function (data, status, xhr) {
                            $('#template-brands-selected-container').html(data);
                        }
                    }
                );
                    
            }
        },

        SaveBrands: function () {
            var me = this;
            var accountService = HSN.Instance()._getAccountService();

            //Have to do our own custom "serialization" here because unchecked boxes arent serialized by default, ugh...
            var serializedValues = [];
            serializedValues = brandSelections;
            var emailId = $('#all-brands-email-id').val();
                    
            serializedValues.push({ 'name': 'EmailId', 'value': emailId });
            serializedValues.push({ 'name': 'Source', 'value': 'AllBrands' });    

            if($('#all-brands-form #select_all').is(':checked')) {
                serializedValues.push({ 'name' : 'CategoryId', 'value' : $('#all-brands-form #select_all').val() });
            }
            else {
                serializedValues.push({ 'name' : 'UnSelectedCategoryId', 'value' : $('#all-brands-form #select_all').val() });
            }
               
            if(emailId != undefined) {
                accountService.SaveBrandChanges(serializedValues, {
                    callback : function(data) {
                        if(data.success) {
                            brandSelections.length = 0;

                            $('#preferences-brands-save-button').removeClass().addClass('animated-save-btn button');
                            me.PopulateBrands(currentCategorySelected, currentBrandNameSelected, true);
                        }

                        else {
                            alert('There was a problem saving your changes.');
                        }
                    }
                });
            }
        },

        SaveSelCatBrands: function () {
            $('.brand-item').each(function (e) {

                var brandItemVal = $(this).val();

                $.each(brandSelections, function (i) {
                    if (this.value == brandItemVal) {
                        $('input[value=' + brandItemVal + ']').prop("checked", true);
                    }

                });
            });
        },

        ShowOrHideContent: function (obj, container, toggleindex) {
            HSN.AnimateAccordion(container, toggleindex, false, false, null);
},

        SaveEmailPreferences: function (redirectUrl) {
            var accountService = HSN.Instance()._getAccountService();
            var email = $('#comm-pref-email').val();

            if (email != '') {
                emailPrefSelections.push({ 'name': 'Email', 'value': email });
                var promoEmails = false;
                if (emailPrefSelections.length > 0 && emailPrefSelections.some(data => data.name === "SelectedEmailPref" && data.value === "3")) {
                    promoEmails = true;
                }
                accountService.SaveEmailPreferenceChanges(emailPrefSelections, {                    

                    callback: function (data) {
                        if (data.success) {
                            if (promoEmails) {
                                dataLayer.push({ 'signup_email': email });
                                HSN.DataLayer.helpers.hsnEvent(null, "EmailPromoSignupCommPrefs", "Success", null, null);
                            }
                            emailPrefSelections = [];
                            HSN.Template.CommPrefBrands.prototype.UpdateEmailOptionSelections();
                            $("#pref-save-applied").removeClass("applied-img-hidden").addClass("applied-img");
                        }
                        else {
                            alert('There was a problem saving your email preferences.');
                        }
                    }
                });
            }
        },

        SaveEmailSubscribe: function () {
            var accountService = HSN.Instance()._getAccountService();
            var email = $('#comm-pref-email').val();

            if (email != '') {
                emailPrefSelections.push({ 'name': 'Email', 'value': email });

                //unsubscribe all
                if($("#email-pref-item_unsubscribeall").prop('checked')) {

                    emailPrefSelections.push({ 'name': 'UnselectedEmailPref', 'value': $("#wtw-email-pref-unsubscribe").val() });
                    $('#wtw-email-pref-unsubscribe').prop("checked", true);

                    $('.email-pref-item-unsubscribe').each(function(e) {
                        emailPrefSelections.push({ 'name': 'UnselectedEmailPref', 'value': $(this).val() });
                        $('.email-pref-item-unsubscribe').prop("checked", true);
                    });

                    var modal = HSN.Instance().GetEmailSurveyModal();
                    modal.Show("/myaccount/compref/email-survey/modal/get/" + email);  

                }
                else {
                        
                    //wtw subscribe / unsubscribe
                    if ($("#wtw-email-pref-subscribe").prop('checked')) {
                        emailPrefSelections.push({ 'name': 'SelectedEmailPref', 'value': $("#wtw-email-pref-subscribe").val() });
                    }

                    if ($("#wtw-email-pref-unsubscribe").prop('checked')) {
                        emailPrefSelections.push({ 'name': 'UnselectedEmailPref', 'value': $("#wtw-email-pref-unsubscribe").val() });
                    }

                    //email preferences subscribe / unsubscribe
                    $('.email-pref-item-subscribe').each(function (e) {

                        if ($(this).prop('checked')) {
                            emailPrefSelections.push({ 'name': 'SelectedEmailPref', 'value': $(this).val() });
                        }
                    });

                    $('.email-pref-item-unsubscribe').each(function (e) {
                        if ($(this).prop('checked')) {
                            emailPrefSelections.push({ 'name': 'UnselectedEmailPref', 'value': $(this).val() });
                        }
                    });
                }

                accountService.SaveEmailPreferenceChanges(emailPrefSelections, {
                    callback: function (data) {
                        if (data.success) {
                            emailPrefSelections = [];

                            $("#pref-save-applied").removeClass("applied-img-hidden").addClass("applied-img");
                        }
                        else {
                            alert('There was a problem saving your email preferences.');
                        }
                    }
                });
            }
        },

        SavePreferences: function () {
            $("#pref-save-applied").removeClass("applied-img").addClass("applied-img-hidden");
            this.SaveEmailPreferences();
        },

        SaveSubscribe: function () {
            $("#pref-save-applied").removeClass("applied-img").addClass("applied-img-hidden");
            this.SaveEmailSubscribe();
        },

        UpdateEmailOptionSelections: function() {
            $('.email-pref-item').each(function (e) {
                if ($(this).is(':checked')) {
                    $(this).attr('originalvalue', 'selected');
                }
                else {
                    $(this).attr('originalvalue', 'unselected');
                }
            });
        }
    };




// WEBPACK FOOTER //
// ./assets/js/HSN/Template/CommPrefBrands.js